<style>
.itemselected {
  border-style: solid;
  border-width: 0em 0em 0em 0.3em;
  border-color: #42a5f5;
  background-color: #42a5f5 !important;
}

.borderwidget {
  border-style: solid;
  border-width: 0 0 0 0.1rem;
  border-color: #002052;
}
.primary {
  background-color: #42a5f5 !important;
}
</style>
<template>
  <v-container
    fill-height
    fluid
    style="position:absolute;left:0;top:0;bottom:0;right:0;overflow-y:scroll;padding:0"
  >
    <v-btn
      v-on:click="drawer = !drawer"
      absolute
      bottom
      fab
      style="z-index:3;bottom:1rem;left:1rem"
      dark
      color="purple"
      ><v-icon>menu</v-icon></v-btn
    >
    <v-layout row wrap>
      <v-navigation-drawer
        absolute
        v-model="drawer"
        :temporary="
          $vuetify.breakpoint.sm | $vuetify.breakpoint.xs ? true : false
        "
        :style="'width: 30rem;padding:1rem;left:' + (!drawer ? '-30rem' : '')"
      >
        <div style="text-align:left; margin:0.5rem;margin-bottom:0.5rem">
          <div class="headline">Guides</div>
          <div class="body-1">
            Select a guide to get more info on how provision your device.
          </div>
        </div>

        <v-layout
          row
          wrap
          align-center
          style="
                        padding-left:1rem;
                        padding-right:1rem;
                        margin-bottom:1rem"
        >
          <v-flex xs12 sm12 md12>
            <v-list two-line>
              <v-list-tile
                v-for="(guide, i) in guides"
                :key="i"
                @click="selectedGuide = guides[i]"
                v-bind:class="{itemselected: guides[i] == selectedGuide}"
                style="margin-bottom:1rem"
              >
                <!-- <v-list-tile-avatar > -->
                <!-- <v-icon v-if="guide.img.icon" big>{{guide.img.icon}}</v-icon>
                                  <img v-if="!guide.img.icon&&guide.title=='FP-ATR-LTE1'" :src="guide.img.path"/>
                                  <img v-if="!guide.img.icon&&guide.title!='FP-ATR-SIGFOX1'&&guide.title!='FP-ATR-LTE1'" :src="guide.img.path" />
                                  <img v-if="!guide.img.icon&&guide.title=='FP-ATR-SIGFOX1'" :src="guide.img.path"/> -->
                <!-- <img alt="" :src="'/assets/technology/'+guide.id +'.png'" />
                              </v-list-tile-avatar> -->
                <img
                  alt=""
                  :src="'/assets/technology/' + guide.id + '.png'"
                  style="width:3rem;margin-right:1rem"
                />
                <v-list-tile-content>
                  <v-list-tile-title>{{ guide.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    guide.text || "More info on " + guide.title
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-navigation-drawer>
      <v-flex
        xs12
        :style="
          'height:100%;margin-left:' +
            (!($vuetify.breakpoint.sm | $vuetify.breakpoint.xs) && drawer
              ? '30rem'
              : '0')
        "
      >
        <v-content
          style="width:100%;height:100%;padding:0;background-color:white;overflow-y:scroll"
          class="elevation-0"
        >
          <div v-if="selectedGuide" style="height:100%;;padding:1rem">
            <component
              @routing="browse($event)"
              v-bind:is="selectedGuide.component"
            ></component>
          </div>
          <div
            v-else
            class="d-flex transition-fast-in-fast-out grey lighten-4 v-card--reveal grey--text text-sm-center"
            style="height: 100%;width:100%;opacity:0.5;;position:absolute;margin-top:-1rem;padding-top:25%"
          >
            <p
              style=";position:absolute;width:100%;padding-top:0.5rem"
              class=" text-sm-center headline"
            >
              <v-icon>menu_book</v-icon> Select a guide
            </p>
          </div>
        </v-content>
      </v-flex>
    </v-layout>
  </v-container>

  <!-- <div style="
      
        position:absolute;
        left:0;top:0;bottom:0;right:0
      margin-left:1rem;margin-top:2rem;">
    <v-container style="width:100%;;" fill-height>
      
      <v-layout >
        <v-flex xs3 style="margin-right:1rem">
          <v-navigation-drawer
            stateless
            value="true"
            style=";width:100%;"
            elevation-1
            class="telemetry-container"
          >

            <v-list two-line>

                <v-list-tile
                    v-for="(guide, i) in guides"
                    :key="i"
                    @click="selectedGuide=guides[i]"
                    v-bind:class="{selected: guides[i]==selectedGuide}"
                    style="margin-bottom:1rem"
                >
                    <v-list-tile-avatar >
                        <v-icon v-if="guide.img.icon" big>{{guide.img.icon}}</v-icon>
                        <img v-if="!guide.img.icon&&guide.title=='FP-ATR-LTE1'" :src="guide.img.path" style="width:1.5rem;height:1.5rem"/>
                        <img v-if="!guide.img.icon&&guide.title!='FP-ATR-SIGFOX1'&&guide.title!='FP-ATR-LTE1'" :src="guide.img.path" style="height:2rem"/>
                        <img v-if="!guide.img.icon&&guide.title=='FP-ATR-SIGFOX1'" :src="guide.img.path" style="height:1rem"/>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                        <v-list-tile-title>{{guide.title}}</v-list-tile-title>
                        <v-list-tile-sub-title >More info on {{guide.title}}</v-list-tile-sub-title>
                    </v-list-tile-content>


                </v-list-tile>

            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs9>
          <v-content 
            style="width:100%;height:100%;padding:0;background-color:white;padding:1rem" 
            
            class="elevation-1 telemetry-container"
            >
            <div v-if="selectedGuide" style="height:100%;">
              <component @routing="browse($event)" v-bind:is="selectedGuide.component"></component>
            </div>
            <div v-else style="height:100%;;border-style: dashed;border-width:0.3rem;border-color:grey;opacity:0.5" >
              <v-layout style="height:100%" align-center justify-center>
              <div style="color:grey"><v-icon big style="font-size:8rem" color="grey">menu_book</v-icon> <h3> No guide selected </h3></div> 
              </v-layout>
            </div>
          </v-content>
        </v-flex>
      </v-layout>
    </v-container>
  </div> -->
</template>
<script>
import LoraHowTo from "@/components/route-components/content-components/HowToLoraNew";
import AstraHowTo from "@/components/route-components/content-components/HowToAstraNew";
import SigfoxHowTo from "@/components/route-components/content-components/HowToSigfoxNew";
import LteHowTo from "@/components/route-components/content-components/HowToLteNew";
import WifiHowTo from "@/components/route-components/content-components/HowToWifiNew";
import HTTPHowTo from "@/components/route-components/content-components/HowToHTTPNew";
import StervalHarvest1HowTo from "@/components/route-components/content-components/HowToStervalHarvest1New";
import DownloadDataHowTo from "@/components/route-components/content-components/HowToDownloadData";

export default {
  mounted() {
    this.selectedGuide = this.guides.find(
      (g) => g.id == this.$route.query.technology
    );
  },

  data() {
    return {
      drawer: true,
      selectedGuide: null,
      guides: [
        {
          id: "polaris",
          component: AstraHowTo,
          title: "STEVAL-ASTRA1B",
          text: "More info on FP-ATR-ASTRA1",
          img: {
            path: "/assets/technology/astra.png",
            style: "width:70%;margin-left:-1rem",
          },
        },
        {
          id: "iotdiscoverykit",
          component: WifiHowTo,
          title: "IoT Discovery Kit",
          text: "More info on FP-CLD-AWS1",
          img: {
            path: "/assets/technology/wifi.png",
            style: "width:30%;",
          },
        },
        {
          id: "pcell02fpatrlte1",
          component: LteHowTo,
          title: "FP-ATR-LTE1",
          img: {
            path: "/assets/technology/lte.png",
            style: "width:30%;",
          },
        },
        {
          id: "sigfox",
          component: SigfoxHowTo,
          title: "FP-ATR-SIGFOX1",
          img: {
            path: "/assets/technology/sigfox.png",
            style: "width:50%;",
          },
        },
        {
          id: "Lora_ttn",
          component: LoraHowTo,
          title: "ST LoRa Tracker",
          text: "More info on FP-ATR-LORA1",
          img: {
            path: "/assets/technology/lora.png",
            style: "width:70%;margin-left:-1rem",
          },
        },
        {
          id: "steval-harvest1:mcu:demo:1",
          component: StervalHarvest1HowTo,
          title: "STEVAL-HARVEST1",
          text: "For more info search STEVAL-HARVEST1 on st.com web site",
          img: {
            path: "/assets/technology/steval-harvest1_mcu_demo_1.png",
            style: "width:70%;margin-left:-1rem",
          },
        },
        {
          id: "http",
          component: HTTPHowTo,
          title: "Generic HTTP Client",
          img: {
            icon: "memory",
          },
        },
        {
          id: "downloaddata",
          component: DownloadDataHowTo,
          title: "Download daily data",
          img: {
            icon: "file",
          },
        },
      ],
    };
  },

  methods: {
    async browse(view) {
      await this.$store.commit("browseApp", view);
    },
  },
};
</script>
